/* Berthaglow custom theme JS: drawers, cart, product form, gallery */
(function () {
  'use strict';

  var overlay = document.getElementById('PageOverlay');

  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
    });
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      openDrawer(document.getElementById(openTrigger.getAttribute('data-drawer-open')));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ------------------------------------------------------------------ */
  /* Money formatting                                                    */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-dot').forEach(function (dot) {
      dot.textContent = count;
      dot.setAttribute('data-count', count);
    });
  }

  function refreshCartDrawer(openAfter) {
    fetch((window.theme.routes.cart || '/cart') + '?view=drawer-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var target = document.getElementById('CartDrawerContent');
        if (target) target.innerHTML = html;
        var countEl = target && target.querySelector('[data-cart-count]');
        if (countEl) updateCartCount(countEl.getAttribute('data-cart-count'));
        initCartTimer();
        if (openAfter) openDrawer(document.getElementById('CartDrawer'));
      });
  }

  window.refreshCartDrawer = refreshCartDrawer;

  /* Cart reservation countdown (FOMO timer). Deadline persists in
     sessionStorage so drawer re-renders don't reset it; restarts on expiry. */
  function initCartTimer() {
    var el = document.querySelector('[data-cart-timer]');
    if (!el) return;
    var minutes = parseInt(el.getAttribute('data-minutes') || '10', 10);
    var key = 'bgCartTimerDeadline';
    var deadline = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60000;
      sessionStorage.setItem(key, deadline);
    }
    if (window.__cartTimerInterval) clearInterval(window.__cartTimerInterval);
    function tick() {
      var target = document.querySelector('[data-cart-timer] [data-timer-value]');
      if (!target) { clearInterval(window.__cartTimerInterval); return; }
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        deadline = Date.now() + minutes * 60000;
        sessionStorage.setItem(key, deadline);
        remaining = deadline - Date.now();
      }
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      target.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
    tick();
    window.__cartTimerInterval = setInterval(tick, 1000);
  }
  document.addEventListener('DOMContentLoaded', initCartTimer);
  initCartTimer();

  /* Testimonials carousel arrows: scroll by one card */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-testi-prev]');
    var next = e.target.closest('[data-testi-next]');
    if (!prev && !next) return;
    var viewport = (prev || next).closest('.testimonials__viewport');
    var track = viewport && viewport.querySelector('[data-testi-track]');
    if (!track) return;
    var card = track.querySelector('.testimonial-card');
    var step = card ? card.offsetWidth : track.clientWidth / 2;
    track.scrollBy({ left: next ? step : -step, behavior: 'smooth' });
  });

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var oldText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () { refreshCartDrawer(true); })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart.');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = oldText; }
      });
  });

  // Quantity changes / removals (works in drawer and cart page)
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('[data-line-key]');
      var input = wrap.querySelector('input[data-qty-input]');
      var qty = Math.max(0, parseInt(input.value || '0', 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
      changeLine(wrap.getAttribute('data-line-key'), qty, wrap);
      return;
    }
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      var lineWrap = removeBtn.closest('[data-line-key]');
      changeLine(lineWrap.getAttribute('data-line-key'), 0, lineWrap);
    }
  });

  function changeLine(key, qty, wrap) {
    fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (wrap.closest('#CartDrawerContent')) {
          refreshCartDrawer(false);
        } else {
          window.location.reload();
        }
      });
  }

  /* ------------------------------------------------------------------ */
  /* Product gallery                                                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    var main = gallery.querySelector('.product-gallery__main img');
    main.src = thumb.getAttribute('data-full-src');
    main.srcset = '';
    gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ------------------------------------------------------------------ */
  /* Variant picker (button style)                                       */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form]').forEach(function (container) {
    var jsonEl = container.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var productData = JSON.parse(jsonEl.textContent);
    var idInput = container.querySelector('input[name="id"]');

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.variant-btn');
      if (!btn) return;
      var group = btn.closest('[data-option-index]');
      group.querySelectorAll('.variant-btn').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      var selected = [];
      container.querySelectorAll('[data-option-index]').forEach(function (g) {
        var sel = g.querySelector('.variant-btn.is-selected');
        selected.push(sel ? sel.getAttribute('data-value') : null);
      });
      var variant = productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      var submits = container.querySelectorAll('[type="submit"], [data-sticky-submit]');
      var priceEls = container.querySelectorAll('[data-price]');
      var compareEls = container.querySelectorAll('[data-compare-price]');
      var saveEls = container.querySelectorAll('[data-save-badge]');

      if (variant) {
        idInput.value = variant.id;
        priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
        compareEls.forEach(function (el) {
          if (variant.compare_at_price > variant.price) {
            el.textContent = formatMoney(variant.compare_at_price);
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        saveEls.forEach(function (el) {
          if (variant.compare_at_price > variant.price) {
            el.textContent = 'SAVE ' + formatMoney(variant.compare_at_price - variant.price);
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        submits.forEach(function (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        });
      } else {
        submits.forEach(function (btn) {
          btn.disabled = true;
          btn.textContent = window.theme.strings.unavailable;
        });
      }
    });
  });

  /* ------------------------------------------------------------------ */
  /* Sticky add-to-cart bar (product pages)                              */
  /* ------------------------------------------------------------------ */
  // Bar button triggers the real product form submit (reuses AJAX add).
  document.addEventListener('click', function (e) {
    var stickyBtn = e.target.closest('[data-sticky-submit]');
    if (!stickyBtn || stickyBtn.disabled) return;
    var form = document.querySelector('.product-page form[data-ajax-cart]');
    if (!form) return;
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  // Show the bar only after the main add-to-cart button scrolls above the viewport.
  (function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var mainSubmit = document.querySelector('.product-page .product-form__submit');
    if (!bar || !mainSubmit || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = entry.boundingClientRect.top < 0;
      var show = !entry.isIntersecting && scrolledPast;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 }).observe(mainSubmit);
  })();
})();
